module.exports = __webpack_public_path__ + "static/media/document-upload-3.53cb9a2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/document-upload-3.jpg
// module id = 445
// module chunks = 0